import styled from 'styled-components'

export const AvatarImg = styled.img<{ width: number; height: number }>`
    border-radius: 2px;
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
    object-fit: cover;
`
